import useEventListener from "./use-event-listener";

export const useResize = (handler: () => void): void => {
  useEventListener("resize", handler);
};
